@let view = vm();
<jui-image-capture
  [images]="view.images"
  [sort]="view.sort"
  [readonly]="view.readonly"
  [dataqastring]="view.key"
  (juiImagesChange)="onImagesChange($event)"
  (juiReject)="onReject($event)"
  (juiCaptureRequest)="onCaptureRequest($event)"
  (juiImageClick)="onImageClick($event)"
>
  @for (item of view.items; track item.id; let i = $index) {
    @if (view.imageQa) {
      <span [attr.slot]="item.overlaySlot" [attr.data-qa]="view.imageQa"></span>
    }
    @if (view.readonly && item.result) {
      <div [attr.slot]="item.verdictSlot" class="image-capture__verdict">
        <crds-metadata-panel
          [classificationResult]="item.result"
          [i18ns]="view.detailI18ns"
          [showBoundingBoxes]="item.showBoxes"
          (boundingBoxToggle)="toggleBoxes(item.id)"
        ></crds-metadata-panel>
      </div>
    } @else if (item.verdict) {
      <div [attr.slot]="item.verdictSlot" class="image-capture__verdict" aria-live="polite">
        <jui-alert-block
          size="sm"
          [color]="item.verdict.tone"
          [iconName]="item.verdict.icon"
          [titleText]="item.verdict.title"
          [animated]="item.verdict.analysing"
        >
          {{ item.verdict.message }}
        </jui-alert-block>
      </div>
    } @else if (item.analysisPending) {
      <div
        [attr.slot]="item.verdictSlot"
        class="image-capture__verdict"
        aria-busy="true"
        [attr.data-qa]="view.key + '_analysisLoading_' + i"
      >
        <jui-skeleton-loader count="4" height="24px"></jui-skeleton-loader>
      </div>
    }
    @if (item.boxes.length) {
      @if (!view.readonly) {
        <jui-button
          [attr.slot]="item.actionsSlot"
          size="sm"
          color="low"
          [attr.aria-pressed]="item.showBoxes"
          [attr.data-qa]="view.key + '_toggleBbox_' + i"
          (click)="toggleBoxes(item.id)"
        >
          {{ view.toggleLabel }}
        </jui-button>
      }
      <div
        [attr.slot]="item.overlaySlot"
        class="image-capture__boxes bounding-box-overlay"
        [class.bounding-box-overlay--visible]="item.showBoxes"
        [attr.data-qa]="view.key + '_boxes_' + i"
        aria-hidden="true"
      >
        @for (box of item.boxes; track $index) {
          <div
            class="image-capture__box"
            [style.left.%]="box.left"
            [style.top.%]="box.top"
            [style.width.%]="box.width"
            [style.height.%]="box.height"
            [style.border-color]="box.colour"
          >
            <span class="image-capture__box-label" [style.color]="box.colour">{{ box.label }}</span>
          </div>
        }
      </div>
    }
  }
</jui-image-capture>
<question-example-images [examples]="view.examples" [key]="view.key"></question-example-images>
@if (view.rejection) {
  <p class="image-capture__rejection" role="alert" [attr.data-qa]="view.key + '_rejection'">{{ view.rejection }}</p>
}
